<template>
  <div>
    <zixun v-if="show"></zixun>
    <ConsultDetails v-else></ConsultDetails>
  </div>
</template>
<script>
import zixun from "./zixun.vue"
import ConsultDetails from "./ConsultDetails/index.vue"
export default{
  components:{
    zixun,
    ConsultDetails
  },
  watch:{
    '$route.query.id':function(newVal,oldVal){
      if(newVal){
        this.show=false
      }else{
        this.show=true
      }
    }
  },
  data(){
    return{
     show:true
    } 
  },
  mounted(){
    if(this.$route.query.id){
      this.show=false
    }else{
      this.show=true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Information.vue